import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import CommonService from "src/modules/data-protection/apis/CommonService";
import { getAssignedUserDisplayName } from "src/modules/data-protection/pages/admin/administration/user-management/tabs-contents/functions/components/functions-table/helpers";

const extractUsers = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (Array.isArray(payload?.users)) {
        return payload.users;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    return [];
};

const useAssignableUsers = (t) => {
    const usersQuery = useQuery({
        queryKey: ["fetch-analyst-and-admin-analyst-list"],
        queryFn: async () => {
            const service = CommonService.getInstance();
            return await service.fetchAnalystAndAdminAnalystList();
        },
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching user list."), {
                type: "error",
            });
        },
    });

    const users = useMemo(
        () => extractUsers(usersQuery.data),
        [usersQuery.data]
    );

    const options = useMemo(
        () =>
            users.map((user) => ({
                value: user.id,
                label:
                    getAssignedUserDisplayName(user) ||
                    user.email ||
                    String(user.id),
                userData: user,
            })),
        [users]
    );

    return {
        usersQuery,
        users,
        options,
        isLoading: usersQuery.isLoading || usersQuery.isFetching,
    };
};

export default useAssignableUsers;
